import { DATA_CACHE_SIZE, FILE_LOCKING_EXTENSIONS, MOUNT_POINT_WINDOWS, } from '@lucidlink/sdk';
export const CACHE_SIZE_SETTING_CHANGED_EVENT_NAME = 'CacheSizeChanged';
export const WINDOWS_MOUNT_POINT_SETTING_CHANGED_EVENT_NAME = 'WindowsMountPointChanged';
export const LOCKING_EXTENSIONS_SETTING_CHANGED_EVENT_NAME = 'LockingExtensionChanged';
export const FILESPACE_SETTING_CHANGED_EVENT_NAME = 'SettingChanged';
export const SettingNameToSpecializedEventName = {
    [DATA_CACHE_SIZE]: CACHE_SIZE_SETTING_CHANGED_EVENT_NAME,
    [MOUNT_POINT_WINDOWS]: WINDOWS_MOUNT_POINT_SETTING_CHANGED_EVENT_NAME,
    [FILE_LOCKING_EXTENSIONS]: LOCKING_EXTENSIONS_SETTING_CHANGED_EVENT_NAME,
};
export const hasSpecializedEvent = (key) => key in SettingNameToSpecializedEventName;
export var MountPointType;
(function (MountPointType) {
    MountPointType["LETTER"] = "Letter";
    MountPointType["PATH"] = "Path";
    MountPointType["UNC"] = "UNC";
})(MountPointType || (MountPointType = {}));
export var LockingExtensionChange;
(function (LockingExtensionChange) {
    LockingExtensionChange["ADD"] = "add";
    LockingExtensionChange["REMOVE"] = "remove";
})(LockingExtensionChange || (LockingExtensionChange = {}));
export var SettingScope;
(function (SettingScope) {
    SettingScope["GLOBAL"] = "Global";
})(SettingScope || (SettingScope = {}));
export const MOUNT_POINT_TYPE_LETTER = /^[A-Za-z]:[/\\]?$/;
